// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3r0NH","rootNoMargin":"styles_rootNoMargin__1GeGT"};